import React from 'react';
import Contactcontent from '../components/Contactcontent';
import Footer from '../components/footer';


const Contactpage = () => {
  return (
    <div className="Contact">
          
          <Contactcontent />
          <Footer />
    </div>
  );
}

export default Contactpage;